module.exports = "/virtual-football/img/video/clubs/england/chelsea.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/england/chelsea.png
// module id = 285
// module chunks = 6